import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { Set } from '~commonInfra/utils/Set';
import {WebClientListResourceFetcher} from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import {ResourceQuery} from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { RemoteRefreshScheduleMapper } from '../models/mappers/RemoteRefreshScheduleMapper';
import { CreateRemoteRefreshScheduleRequest } from '../serverApi/requests/remoteExtractRefresh/CreateRemoteRefreshScheduleRequest';
import { DeleteRemoteRefreshSchedulesRequest } from '../serverApi/requests/remoteExtractRefresh/DeleteRemoteRefreshSchedulesRequest';
import { GetRemoteRefreshSchedulesRequest } from '../serverApi/requests/remoteExtractRefresh/GetRemoteRefreshSchedulesRequest';
import { UpdateRemoteRefreshExpectedDurationRequest } from '../serverApi/requests/remoteExtractRefresh/UpdateRemoteRefreshExpectedDurationRequest';
import { UpdateRemoteRefreshScheduleRequest } from '../serverApi/requests/remoteExtractRefresh/UpdateRemoteRefreshScheduleRequest';

export class RemoteRefreshSchedulesResource {

  private fetcher = new WebClientListResourceFetcher(
    GetRemoteRefreshSchedulesRequest, ServerApiMapper.remoteRefreshSchedules);

  public all(): ResourceQuery<IRemoteRefreshScheduleInfo>{
    return new ResourceQuery(this.fetcher);
  }

  public create(targetId: string, item: IRemoteRefreshScheduleInfo): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateRemoteRefreshScheduleRequest({
      targetId: targetId,
      definition: '',
      refreshType: item.refreshType,
      schedule: {
        definition: '',
        refreshType: item.refreshType,
        scheduleDetails: item.scheduleDetails,
        scheduleType: item.scheduleType
      }
    }));
  }

  public update(targetId: string, initialSchedule: IRemoteRefreshScheduleInfo, finalSchedule: IRemoteRefreshScheduleInfo): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateRemoteRefreshScheduleRequest({
      targetId: targetId,
      initial: RemoteRefreshScheduleMapper.mapSingleToApi(initialSchedule),
      final: RemoteRefreshScheduleMapper.mapSingleToApi(finalSchedule)
    }));
  }

  public del(targetId: string, items: Set<IRemoteRefreshScheduleInfo>): Promise<IResult> {
    const schedules = items.toArray();
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(schedules, (schedulesBlock) =>
        new DeleteRemoteRefreshSchedulesRequest({
          targetId: targetId,
          schedules: RemoteRefreshScheduleMapper.mapToApi(schedulesBlock)
      })),
      ResultHelper.combineResults);
  }

  public updateExpectedDuration(targetId: string, finalSchedule: IRemoteRefreshScheduleInfo): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateRemoteRefreshExpectedDurationRequest({
      id: targetId,
    expectedRefreshDuration: (String)(finalSchedule.expectedRefreshDuration)
    }));
  }

}

export const RemoteRefreshSchedules = new RemoteRefreshSchedulesResource();